import {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useSearchParams} from "react-router-dom";
import venifyLogo from "../../venifyLogo.png"
import Api from "../../tools/service";
import Container from "../../components/Container";

import LoadingScreen from "../../components/LoadingScreen";
import {MdAlternateEmail} from "react-icons/md";
import {TbWorldWww} from "react-icons/tb";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import WidgetRules from "./WidgetRules";

const IAuthReports = () => {
    const [token, setToken] = useOutletContext();

    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true)
    const [AuthDate, setAuthDate] = useState()
    const [searchParams] = useSearchParams();
    const ref = searchParams.get('ref');

    const navigate = useNavigate();
   /* useEffect(() => {

        if (token) {
            getReports()
        }
    }, [token]);*/
    useEffect(() => {
        getReports()
    }, []);
    const getReports = () => {

        setLoading(true)
        Api.get(`api/v1/Public/Authentications/${ref}`, {
            params: {
                g_response: token,
            }
        }).then(response => {

            if (!response.hasError) {

                setInfo(response.data)

                const date = new Date(response.data.auth_date * 1000);
                const formatter = new Intl.DateTimeFormat('fa-IR', {
                    month: "long",
                    day: "numeric",
                    calendar: "persian",
                    year: "numeric"
                });
                setAuthDate(formatter.format(date))
            } else {
                navigate('/notfound')
            }
        }).catch(e => {

        }).finally(() => {
            setLoading(false)
        })
    }
    if (loading) {
        return <LoadingScreen/>
    }


    function imageData(str) {
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

        if (urlRegex.test(str)) {
            return str;
        } else {

            return "data:image/png;base64," + str
        }
        ;
    }

    return <div className="  ">

        <Container className="flex  font-sm rtl mt-5 lg:mt-16  items-center  flex-col justify-center">
            <div className=" items-center w-full mb-2 rounded-xl  flex bg-white p-5  ">
                <a className="w-16" href="https://venify.ir">
                    <img className="w-16" src={venifyLogo} alt=""/>
                </a>
                <div className="flex mr-2 flex-col">
                    <a href="https://venify.ir">
                        <h1 className="text-xl    font-bold  ">ونیفای</h1>
                    </a>
                    <p className="  text-sm  "> ارائه دهنده سرویس‌های هوشمند مالی و بانکی در جهت سهولت و مجازی‌سازی خدمات</p>
                </div>
            </div>
            <div dir="rtl" className="w-full flex   flex-col lg:grid lg:grid-cols-6   lg:flex-row lg:items-stretch lg:gap-2 ">

                {info && <div className="bg-white lg:col-span-2 flex flex-col justify-between  mb-3 lg:mb-0  p-5 rounded-xl ">
                    <div className="w-full">

                        {info?.available_services?.includes(AuthenticationDefaultSteps.IAuth) &&
                            <div className="w-full border-b pb-2  flex justify-start items-center  ">
                                <img
                                    src={info?.widget_body?.face_img && !info?.deleted_widgets.includes(AuthenticationDefaultSteps.IAuth) ? imageData(info?.widget_body?.face_img) : info.widget_body?.def_user_img_url}
                                    className="w-16   rounded-lg h-auto" alt=""/>
                                <div className="mr-3 flex flex-col">
                                    <strong>{info?.widget_body?.full_name}</strong>
                                    <span className="text-sm ">{info?.widget_body?.person_section_sub_title}</span>
                                </div>

                            </div>}

                        <div className=" w-full my-3 "></div>
                        {!info?.deleted_widgets.includes(AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY) && info?.widget_body?.bi_type &&
                            <div className="w-full flex  mb-2 mt-2    rounded-lg flex-col   ">
                                <div className="justify-start flex items-center">
                                    <img src={info.widget_body.bi_sub_logo_url} className="w-16 border-t rounded-lg  h-auto"
                                         alt=""/>
                                    <div className="mr-3 flex flex-col">
                                        <strong>{info.widget_body.bi_logo_title}</strong>

                                    </div>
                                </div>

                                <div className="grid grid-cols-1 mt-2   ">
                                    <div className="flex  justify-between border-t  py-3 items-center ">
                                        <span className="text-sm ">رسته</span>
                                        <span className="font-semibold text-sm  ">{info?.widget_body?.bi_field}</span>
                                    </div>
                                    <div className="flex justify-between border-t py-3  items-center ">
                                        <span className="text-sm ">استان</span>
                                        <span className="font-semibold text-sm  ">{info?.widget_body?.bi_state}</span>
                                    </div>
                                    <div className="flex justify-between border-t py-3   items-center ">
                                        <span className="text-sm ">شهر</span>
                                        <span className="font-semibold text-sm">{info?.widget_body?.bi_city}</span>
                                    </div>

                                </div>
                            </div>}
                        {info.widget_body?.li_status &&
                            <div className="w-full flex mb-2 bg-gray-50  flex-col rounded-lg  p-3 ">
                                <div className="justify-start flex items-center">
                                    <img src={info?.widget_body?.li_sub_logo_url} className="w-16 border h-auto" alt=""/>
                                    <div className="mr-3 flex flex-col">
                                        <strong>{info?.widget_body?.li_logo_title}</strong>
                                        <span className="text-sm ">{info?.widget_body?.li_club}</span>
                                    </div>
                                </div>
                                <div className="grid border-t mt-2  pt-2 w-full  grid-cols-2">
                                    <div className="flex border-l flex-col mt-2 items-center justify-center">
                                        <span className="text-sm ">وضعیت</span>
                                        <span className="font-bold text-sm mt-2 ">{info?.widget_body?.li_status}</span>
                                    </div>
                                    <div className="flex  flex-col mt-2 items-center justify-center">
                                        <span className="text-sm ">تاریخ اعتبار</span>
                                        <span className="font-bold text-sm mt-2 ">{info?.widget_body?.li_exp_date}</span>
                                    </div>
                                </div>

                            </div>}
                        {info?.widget_body?.ei_status &&
                            <div className="w-full flex mb-2 bg-gray-50 flex-col rounded-lg  p-3 ">
                                <div className="justify-start flex items-center">
                                    <img src={info?.widget_body?.ei_sub_logo_url} className="w-16 border h-auto" alt=""/>
                                    <div className="mr-3 flex flex-col">
                                        <strong>{info?.widget_body?.ei_logo_title}</strong>
                                        <span className="text-sm ">{info?.widget_body?.ei_club}</span>
                                    </div>
                                </div>
                                <div className="grid border-t mt-2  pt-2 w-full  grid-cols-2">
                                    <div className="flex border-l flex-col mt-2 items-center justify-center">
                                        <span className="text-sm ">وضعیت</span>
                                        <span className="font-bold text-sm mt-2 ">{info.widget_body.ei_status}</span>
                                    </div>
                                    <div className="flex  flex-col mt-2 items-center justify-center">
                                        <span className="text-sm ">تاریخ اعتبار</span>
                                        <span className="font-bold text-sm mt-2 ">{info?.widget_body?.ei_exp_date}</span>
                                    </div>
                                </div>

                            </div>}
                        {info?.widget_body?.police_clearance_status &&
                            <div className="w-full flex mb-2  flex-col rounded-lg   ">
                                <div className="justify-start flex items-center">
                                    <img src={info?.widget_body?.pi_sub_logo_url} className="w-16 border rounded-xl h-auto" alt=""/>
                                    <div className="mr-3 flex flex-col">
                                        <strong>{info?.widget_body?.pi_logo_title}</strong>

                                    </div>

                                </div>
                                <div className="grid  mt-2  pt-2 w-full grid-cols-1">
                                    <div
                                        className="flex justify-between border-t   py-3  w-full items-center ">
                                        <span className="text-sm ">وضعیت </span>
                                        <span
                                            className="font-semibold text-sm">{info.widget_body.police_clearance_status}</span>
                                    </div>
                                    <div
                                        className="flex justify-between border-t  py-3  w-full items-center ">
                                        <span className="text-sm ">تاریخ استعلام</span>
                                        <span
                                            className="font-semibold text-sm">{info?.widget_body?.police_clearance_date}</span>
                                    </div>

                                </div>


                            </div>}
                    </div>
                    <div
                        className="grid grid-cols-1      ">

                        <div className="flex justify-between border-t lg:border-t-0 py-3  w-full items-center ">
                            <span className="text-sm ">تاریخ ساخت افزونه</span>
                            <span className="font-semibold text-sm">{AuthDate}</span>
                        </div>
                        {info.btns.map((btn, index) => {
                            return <a href={btn.url} className="w-full  " key={index}>
                                <button className=" btn btn-green   text-sm w-full   rounded-lg  ">
                                    {btn.title}
                                </button>
                            </a>
                        })}

                    </div>

                </div>}
                <WidgetRules/>

            </div>
            <div dir="rtl"
                 className="w-full    mt-4 text-sm      text-center flex justify-center items-center flex-col ">
                <div className="grid grid-cols-2 lg:grid-cols-2  w-full  gap-3 ">
                    <div className=" p-5 col-span-1 bg-white flex justify-start items-center text-gray-800 rounded-xl">
                        <TbWorldWww className="text-xl"/>
                        <div className="flex  mr-3 flex-col items-start justify-start">
                            <p className="text-gray-800 mb-1">آدرس وبسایت</p>
                            <a href="https://venify.ir" className="text-gray-800 font-bold">https://venify.ir</a>
                        </div>
                    </div>
                    <div className=" p-5 col-span-1 bg-white flex justify-start  items-center text-gray-800 rounded-xl">
                        <MdAlternateEmail className="text-xl"/>
                        <div className="flex mr-3 flex-col items-start justify-start">

                            <p className="text-gray-700 text-sm mb-1">ایمیل</p>
                            <a href="mailto:info@venify.ir" className=" font-bold">info@venify.ir</a>
                        </div>
                    </div>

                </div>
                <div className="w-full border-t mt-5 "></div>
                <p className="mt-2 text-sm ">تمامی حقوق مربوط به این وب‌سایت، متعلق به شرکت <a
                    className="text-red-600 font-bold" href="https://asredade.com">عصرداده</a> می باشد.</p>
            </div>
        </Container>


    </div>
}
export default IAuthReports;